import { render, staticRenderFns } from "./importClass.vue?vue&type=template&id=6a0a5341&"
import script from "./importClass.vue?vue&type=script&lang=js&"
export * from "./importClass.vue?vue&type=script&lang=js&"
import style0 from "./importClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports